export const transliterate = (text = ''): string => {
  return (text.normalize ? text.normalize() : text)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
    .split('')
    .map((letter) => associations.get(letter) ?? letter)
    .join('')
    .replace(/[^A-Za-z0-9-]/g, '') // убираем невалидные символы &, ', ?, !, умлауты и т.п.
    .replace(/-+/g, '-');
};

const associations = new Map([
  ['а', 'a'],
  ['б', 'b'],
  ['в', 'v'],
  ['г', 'g'],
  ['д', 'd'],
  ['е', 'e'],
  ['ё', 'e'],
  ['ж', 'zh'],
  ['з', 'z'],
  ['и', 'i'],
  ['й', 'y'],
  ['к', 'k'],
  ['л', 'l'],
  ['м', 'm'],
  ['н', 'n'],
  ['о', 'o'],
  ['п', 'p'],
  ['р', 'r'],
  ['с', 's'],
  ['т', 't'],
  ['у', 'u'],
  ['ф', 'f'],
  ['х', 'h'],
  ['ц', 'c'],
  ['ч', 'ch'],
  ['ш', 'sh'],
  ['щ', 'shch'],
  ['ъ', ''],
  ['ы', 'y'],
  ['ь', ''],
  ['э', 'e'],
  ['ю', 'yu'],
  ['я', 'ya'],
  [' ', '-'],
  ['.', '-'],
]);
